const allCapitalLetterGroups = /[A-ZÀ-ÖÙ-Ý]+/g
const allLowercaseWords = /[a-zà-öù-ý]+/g
/**
 *	Converts a string value into [kebab case](https://en.wikipedia.org/wiki/Kebab_case).
 * @param value The string to convert.
 * @category String
 * @returns The kebab-cased string.
 * @example
kebabCase('fooBARBaz')
// => 'foo-bar-baz'
 */
export default function kebabCase(value) {
	const words = value
		.replace(allCapitalLetterGroups, brokenLowered)
		.match(allLowercaseWords)
	return words ? words.join('-') : ''
	function brokenLowered(s) {
		return (
			' ' +
			(s.length > 2 ? s.slice(0, -1) + ' ' + s.slice(-1) : s).toLowerCase()
		)
	}
}
